import Axios from 'axios'

import Cart from '@/cart'
import Notification from '@/notification'

import { fn } from '@/globals'

// URL and endpoint constants
const LOGIN_URL = 'cart/api/login/request'

export default {

  async action(code, action, payload) {
    try {
      let payFn = fn.httpsCallable('calls-commerce-cart-pay')
      let response = await payFn({
        action: action,
        shopId: Cart.shopId,
        cartId: Cart.cartId,
        gateCode: code,
        body: payload
      })
      console.log(`Action ${action}@${code} response:`, response)
      if (response.data.status == 'error') {
        this.submitFailed()
        return {}
      } else {
        return response.data
      }
    } catch (e) {
      console.error(`Action ${action}@${code} failed:`, e)

      this.submitFailed()

      return null
    }
  },

  submitFailed() {
    Cart.data.processingState = 'failed'
    Cart.globals.overlayActive = false
    setTimeout(() => {
      Cart.data.processingState = 'init'
    }, 2000)
  },

}
